import React, { Component, Fragment } from "react";
import { oneOfType, string, func, bool } from "prop-types";
import { connect } from "react-redux";
import { push } from "connected-react-router";
import { REGION_ARG } from "constants.js";

import { actions as loansActions } from "reducers/loans";
import { selectors as settingsSelectors, actions as settingsActions } from "reducers/settings";
import { actions as environmentActions } from "reducers/environment";

import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import TextField from "pages/_components/fields/TextField";
import * as i18nUtils from "util/i18n";

import Head from "pages/_components/Head";
import Notification from "pages/_components/Notification";
import MainContainer from "pages/_components/MainContainer";
import { Row, Col } from "react-bootstrap";
import Button from "pages/_components/Button";
import PhoneInput from "pages/_components/fields/PhoneInput";

const FORM_ID = "loans";
class SolicitudDatos extends Component {
    static propTypes = {
        dispatch: func.isRequired,
        mobilePhone: string.isRequired,
        mail: string.isRequired,
        clientName: string.isRequired,
        clientLastName: string.isRequired,
        isDesktop: oneOfType([string, bool]),
        isMobile: oneOfType([string, bool]),
        fetching: oneOfType([string, bool]),
    };

    static defaultProps = {
        isDesktop: false,
        isMobile: false,
        fetching: false,
    };

    constructor(props) {
        super(props);
        this.formRef = React.createRef();
    }

    componentDidMount() {
        const { dispatch } = this.props;
        dispatch(loansActions.listLoansV2());
        dispatch(settingsActions.getUserData());
        dispatch(environmentActions.getComplementaryDataSelectors());
    }

    renderHeader = () => <Head title="menu.loans.aplication" titleText="Solicitud de datos" />;

    btnHandlerOnClick = () => {
        const { dispatch } = this.props;
        dispatch(push("/form/requestLoan/"));
    };

    handleOnSubmit = (formikPropsParam, event, data) => {
        event.stopPropagation();
        formikPropsParam.onSubmit(event, data);
    };

    render() {
        const { fetching, mobilePhone, mail, clientLastName, clientName } = this.props;
        const isLoading = fetching;
        const defaultPhoneNumber = mobilePhone;

        if (mail && clientName && this.formRef.current) {
            this.formRef.current.setFieldValue("email", mail);
            this.formRef.current.setFieldTouched("email", false, false);
            this.formRef.current.setFieldValue("lastname", clientLastName);
            this.formRef.current.setFieldTouched("lasname", false, false);
            this.formRef.current.setFieldValue("name", clientName);
            this.formRef.current.setFieldTouched("name", false, false);
            this.formRef.current.setFieldValue("phone", { prefix: "", value: mobilePhone });
            this.formRef.current.setFieldTouched("phone", false, false);
        }
        // const validateForm = (val) => {
        //     if (val === "" || val === null || val === undefined) {
        //         return false;
        //     }
        //     if (val.split("").filter((x) => x === "9").length > 6) {
        //         return false;
        //     }
        //     if (val.split("").filter((x) => x === "8").length > 6) {
        //         return false;
        //     }
        //     if (val.split("").filter((x) => x === "7").length > 6) {
        //         return false;
        //     }
        //     if (val.split("").filter((x) => x === "6").length > 6) {
        //         return false;
        //     }
        //     if (val.split("").filter((x) => x === "5").length > 6) {
        //         return false;
        //     }
        //     if (val.split("").filter((x) => x === "4").length > 6) {
        //         return false;
        //     }
        //     if (val.split("").filter((x) => x === "3").length > 6) {
        //         return false;
        //     }
        //     if (val.split("").filter((x) => x === "2").length > 6) {
        //         return false;
        //     }
        //     if (val.split("").filter((x) => x === "1").length > 6) {
        //         return false;
        //     }
        //     if (val.split("").filter((x) => x === "0").length > 6) {
        //         return false;
        //     }
        //     return true;
        // };
        const formikValidateProps = {
            validateOnChange: true,
            validateOnBlur: false,
            initialValues: {
                name: clientName,
                lastname: clientLastName,
                document: "",
                phone: { prefix: "", value: mobilePhone },
                email: mail,
            },
            validationSchema: () =>
                Yup.object().shape({
                    name: Yup.string(),
                    lastname: Yup.string(),
                    document: Yup.string(),
                    phone: Yup.object().shape({
                        prefix: Yup.string(),
                        value: Yup.string().required(i18nUtils.get("global.error.required")),
                    }),
                    email: Yup.string().required(i18nUtils.get("global.error.required")),
                }),
            onSubmit: () => {
                // const { name, lastname, document, phone, email } = data;
            },
        };

        return (
            <Fragment>
                <Notification scopeToShow="loans" />
                {!isLoading && this.renderHeader()}
                <MainContainer showLoader={isLoading} className="desktop">
                    <Formik {...formikValidateProps} ref={this.formRef}>
                        {(allFormik) => (
                            <Form className="above-the-fold" noValidate>
                                <Row>
                                    <Col lg={12}>
                                        <div className="box box-shadow banner md:grid-cols-2">
                                            <Row>
                                                <Col lg={6}>
                                                    <Field
                                                        component={TextField}
                                                        idForm={FORM_ID}
                                                        name="name"
                                                        labelTextDefault={`${i18nUtils.get(
                                                            "forms.template.templateName.label",
                                                            "Nombre",
                                                        )}`}
                                                        hidePlaceholder
                                                    />
                                                </Col>
                                                <Col lg={6}>
                                                    <Field
                                                        component={TextField}
                                                        idForm={FORM_ID}
                                                        name="lastname"
                                                        labelTextDefault={`${i18nUtils.get(
                                                            "administration.users.export.lastName",
                                                            "Apellido",
                                                        )}`}
                                                        hidePlaceholder
                                                    />
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col lg={6}>
                                                    <Field
                                                        component={TextField}
                                                        idForm={FORM_ID}
                                                        name="document"
                                                        labelTextDefault={`${i18nUtils.get(
                                                            "checks.control.document",
                                                            "Documento",
                                                        )}`}
                                                        hidePlaceholder
                                                    />
                                                </Col>
                                                <Col lg={6}>
                                                    <Field
                                                        component={PhoneInput}
                                                        idForm={FORM_ID}
                                                        name="phone"
                                                        country={REGION_ARG}
                                                        mobilePhone={defaultPhoneNumber || "54"}
                                                        enableSearch={false}
                                                        preferredCountries={["ar"]}
                                                        labelTextDefault={i18nUtils.get(
                                                            "administration.users.invite.mobilePhone.label",
                                                            "Celular",
                                                        )}
                                                        hintLabel={i18nUtils.get(
                                                            "onboarding.step.verifySMS.mobilePhone.description",
                                                            "Debés incluir el código de área y luego tu nº de teléfono.",
                                                        )}
                                                    />
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col lg={6}>
                                                    <Field
                                                        component={TextField}
                                                        idForm={FORM_ID}
                                                        name="email"
                                                        labelTextDefault={`${i18nUtils.get(
                                                            "loans.aplication.email",
                                                            "Email coorporativo",
                                                        )}`}
                                                        hidePlaceholder
                                                    />
                                                </Col>
                                            </Row>
                                        </div>
                                    </Col>
                                </Row>
                                <Row style={{ textAlign: "center" }}>
                                    <Col lg={4} />
                                    <Col lg={4}>
                                        <Button
                                            bsStyle="primary"
                                            label="onboarding.step.verifySMS.modal.button.validate"
                                            loading={false}
                                            onClick={(ev) =>
                                                this.handleOnSubmit(formikValidateProps, ev, allFormik.values)
                                            }
                                            block
                                            disabled={
                                                !(
                                                    allFormik.isValid &&
                                                    allFormik.dirty &&
                                                    allFormik.values.name?.length > 1 &&
                                                    allFormik.values.lastname?.length > 1 &&
                                                    allFormik.values.phone?.value?.length > 1
                                                )
                                            }
                                            id="submit-button"
                                        />
                                    </Col>
                                    <Col lg={4} />
                                </Row>
                            </Form>
                        )}
                    </Formik>
                </MainContainer>
            </Fragment>
        );
    }
}

const mapStateToProps = (state) => ({
    fetching: settingsSelectors.isFetching(state),
    mobilePhone: settingsSelectors.getMobilePhone(state) || "",
    mail: settingsSelectors.getEmail(state) || "",
    clientLastName: settingsSelectors.getLastName(state) || "",
    clientName: settingsSelectors.getName(state) || "",
});

export default connect(mapStateToProps)(SolicitudDatos);
